import type { GridColDef } from '@mui/x-data-grid';
import type { InvoiceOverview } from '@vy/api-definition';
import { isSingleItem } from '@vy/utils';
import { VyTooltip } from '../../../../../../../components/new-design/VyTooltip';
import { Price } from '../../../../../../../components/design/Price';
import { formatDate } from '../../../../../../../utils/date';
import { getRecipients } from '../SendReminder';

export const INVOICE_DETAILS_TABLE_KEYS = Object.freeze({
  INVOICE_ID: 'invoice.id',
  CUSTOMER_NAME: 'customer.name',
  CUSTOMER_EMAIL: 'customerEmail',
  ISSUE_DATE: 'issueDate',
  AMOUNT: 'amount',
} as const);

export const INVOICE_DETAILS_TABLE_COLUMNS: GridColDef<InvoiceOverview>[] = [
  {
    field: INVOICE_DETAILS_TABLE_KEYS.INVOICE_ID,
    headerName: 'Invoice number',
    headerClassName: 'p-0',
    valueGetter: (_value, row) => row.invoiceNumber,
    width: 150,
    sortable: false,
  },
  {
    field: INVOICE_DETAILS_TABLE_KEYS.CUSTOMER_NAME,
    headerName: 'Customer',
    valueGetter: (_value, row) => row.customer.name,
    width: 200,
    sortable: false,
  },
  {
    field: INVOICE_DETAILS_TABLE_KEYS.CUSTOMER_EMAIL,
    headerName: 'Email',
    width: 200,
    sortable: false,
    renderCell: ({ row }) => {
      const contacts = row.customer.contacts ?? [];
      const emails = getRecipients(contacts);

      return (
        <VyTooltip tooltipContent={emails.join(', ')}>
          <span className="text-label font-sans">
            {!isSingleItem(emails) ? `${emails.length} emails` : emails}
          </span>
        </VyTooltip>
      );
    },
  },
  {
    field: INVOICE_DETAILS_TABLE_KEYS.ISSUE_DATE,
    headerName: 'Issue Date',
    valueGetter: (_value, row) => row.issuedAt,
    valueFormatter: (value) => formatDate(value),
    width: 200,
    sortable: false,
  },
  {
    field: INVOICE_DETAILS_TABLE_KEYS.AMOUNT,
    headerName: 'Amount',
    width: 200,
    sortable: false,
    valueGetter: (_value, row) => row.revenueBreakdown.total,
    renderCell: (params) => {
      const amount = params.row.revenueBreakdown.total;
      const currency = params.row.currency;

      return (
        <span className="text-label font-sans">
          <Price className="font-sans text-black" sx={{ fontSize: 14 }} currency={currency}>
            {amount}
          </Price>
        </span>
      );
    },
  },
];
